import React, {useEffect, useState} from "react";

export default function useDimensions(ref?: React.RefObject<HTMLElement>) {
    const [dimensions, setDimensions] = useState<{ width: number; height: number }>({ width: 0, height: 0 });

    useEffect(() => {
        const element = ref?.current || document.documentElement;

        const updateDimensions = (entries: ResizeObserverEntry[]) => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                setDimensions({ width, height });
            }
        };

        const observer = new ResizeObserver(updateDimensions);
        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [ref]); // rerun if the ref target changes

    return dimensions;
}
